<template>
  <v-sheet>
    <template v-for="block in blocks">
      <v-sheet :key="block.id" v-if="block.type_id=='field'" class="pa-2 mb-3">
        <div
          class="text-capitalize overline text--secondary"
          v-if="block.fieldObject"
        >{{block.fieldObject.name}}</div>
        <field-object v-if="block.fieldObject" :field="block.fieldObject" />
      </v-sheet>
      <field-group :key="block.id" v-else :blocks="block.blocks" />
    </template>
  </v-sheet>
</template>

<script>
import FieldObject from "./FieldObject";
export default {
  components: {
    FieldObject
  },
  name: "field-group",
  props: {
    blocks: {
      type: Array
    }
  }
};
</script>